module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0118-small-e395de562f55672627101853473fb950.jpg";